import script from "./FilterFlex.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterFlex.vue?vue&type=script&lang=ts&setup=true"

import "./FilterFlex.vue?vue&type=style&index=0&id=49f2a1bd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f2a1bd"]])

export default __exports__